import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataEngagementApiModule } from '@epicuro-next/data/engagement/engagement-api';
import { ProductDataModule } from '@epicuro-next/data/product';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';
import { PBasketStateModule } from '@epicuro-next/state/p-basket-state';
import { ProductEntitiesModule } from '@epicuro-next/state/product-entities';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { initial, reducer } from './state';
import { LIST_ENTITIES_STATE_KEY } from './state/constants';
import { ListEntitiesProductsEffects } from './state/effects/list-entities-products.effects';
import { ListEntitiesEffects } from './state/list-entities.effects';

@NgModule({
  imports: [
    CommonModule,
    DataEngagementApiModule,
    PBasketStateModule,
    ProductDataModule,
    ProductEntitiesModule,
    EffectsModule.forFeature([
      ListEntitiesEffects,
      ListEntitiesProductsEffects,
    ]),
    StoreModule.forFeature(LIST_ENTITIES_STATE_KEY, reducer, {
      metaReducers: [resetStateMetaReducer(initial)],
    }),
    DataEngagementApiModule,
  ],
})
export class ListEntitiesModule {}
